// @ts-nocheck
// import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext"; // Starter Custom Code
import translate from "@insite/client-framework/Translate";
import ProductSearchScoreData from "@insite/content-library/Components/ProductSearchScoreData";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions";
// import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage"; // Starter Custom Code
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
// import React, { FC } from "react"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, ProductContextModel, withProduct } from "@insite/client-framework/Components/ProductContext";
import { VariantDisplayTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductAddToListLink from "@insite/content-library/Components/ProductAddToListLink";
import ProductAttributes from "@insite/content-library/Components/ProductAttributes";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductListVariantSwatch from "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import { flexWrapperGapOffsetStyles, flexWrapperGapStyles } from "@store/Library/Components/Toolkit/FlexWrapper";
import { BadgeProps, BadgeTypeValues } from "@store/MobiusOverrides/Badge/Badge";
import { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes";
import {
    ProductAvailabilityStyles,
    useShowProductAvailability,
} from "@store/Overrides/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductTextBadges, { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import ProductListProductImage, {
    productImageStyles,
    ProductListProductImageStyles,
} from "@store/Overrides/Widgets/ProductList/ProductListProductImage";
import { badgeProps } from "@store/Themes/common/props/badge";
import { productCardProps } from "@store/Themes/common/props/productCard";
import { productLineProps } from "@store/Themes/common/props/productLine";
import useCurrentBreakpointValue from "@toolkit/Framework/Common/Hooks/useCurrentBreakpointValue";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import React, { FC, useMemo } from "react";

/* Store Custom Code - Start */
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
/* Store Custom Code - End */

const imageBadgesNumberOfColumnsPerBreakpoint: Array<number | undefined> = [4, 8];
const textBadgesPaddingPerBreakpoint: Array<BadgeProps["badgeTextPadding"]> = [pxToRem(4, 8), undefined];
/* Starter Custom Code - End */

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductCardStyles {
    gridContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    actionsGridItem?: GridItemProps;
    searchScoreDataGridItem?: GridItemProps;
    sponsoredText?: TypographyPresentationProps;
    // Starter Custom Code
    imageWrapper?: InjectableCss;
    productListProductImage?: ProductListProductImageStyles;
    productInfoContainer?: GridContainerProps;
    descriptionGridItem?: GridItemProps;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    badgesGridItem?: GridItemProps;
    productTextBadges?: ProductTextBadgesStyles;
    productImageBadges?: ProductImageBadgesStyles;
    partNumbersGridItem?: GridItemProps;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    attributes?: ProductAttributesStyles;
    availabilityGridItem?: GridItemProps;
    swatchGridItem?: GridItemProps;
    productAvailabilityStyles?: ProductAvailabilityStyles;
    priceAndAvailabilityGridItem?: GridItemProps;
    priceAndAvailabilityInnerContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    productPriceStyles?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    uomAndQuantityGridItem?: GridItemProps;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
}

export const productCardStyles: ProductListProductCardStyles = {
    gridContainer: productLineProps.contentContainer,
    leftColumnGridItem: productLineProps.imageGridItem,
    imageWrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(6))};
        `,
    },
    productListProductImage: {
        productImage: productLineProps.image,
        badgeProductImageInOverlay: productLineProps.image,
        badgeImageWrapper: mergeProps(badgeProps.badgeImageWrapper, {
            css: css`
                width: 3em;

                ${breakpoint("xs", "only")} {
                    width: 2.5em;
                }
            `,
        }),
        badgeTextWrapper: mergeProps(badgeProps.badgeTextWrapper, {
            css: css`
                ${breakpoint("xs", "only")} {
                    position: relative;
                    display: inline-flex;
                    left: unset;
                    right: unset;
                    margin: ${pxToRem(5)} 0 0 0;
                }
            `,
        }),
        compareCheckbox: productImageStyles.compareCheckbox,
    },
    sponsoredText: productCardProps.sponsoredText,
    rightColumnGridItem: productLineProps.contentGridItem,
    /* Store Custom Code - Start */
    rightColumnGridContainer: mergeProps(productLineProps.contentContainer, {
        css: css`
            ${productLineProps.contentContainer?.css}

            && > ${GridOffset} {
                height: 100%;
            }

            && > ${GridOffset} > ${GridItemStyle}:last-child {
                margin-top: auto;
            }
        `,
    }),
    /* Store Custom Code - End */
    infoGridItem: productLineProps.infoGridItem,
    productInfoContainer: productLineProps.infoContainer,
    descriptionGridItem: productLineProps.descriptionGridItem,
    productBrandStyles: productLineProps.brand,
    productDescriptionStyles: mergeProps<ProductListProductCardStyles["productDescriptionStyles"]>(
        productLineProps.description,
        {
            wrapper: {
                forwardAs: "h2",
            },
        },
    ),
    partNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbersStyles: productLineProps.partNumbers,
    attributes: productLineProps.attributes,
    availabilityGridItem: productLineProps.availabilityGridItem,
    productAvailabilityStyles: productLineProps.availability,
    swatchGridItem: productLineProps.swatchGridItem,
    badgesGridItem: productLineProps.badgesGridItem,
    productTextBadges: mergeProps<ProductListProductCardStyles["productTextBadges"]>(productCardProps.textBadges, {
        tagWrapper: {
            extendedStyles: {
                content: {
                    css: css`
                        ${breakpoint("xs", "only")} {
                            ${flexWrapperGapOffsetStyles(pxToRem(6))}
                        }
                    `,
                },
                item: {
                    css: css`
                        ${breakpoint("xs", "only")} {
                            ${flexWrapperGapStyles(pxToRem(6))}
                        }
                    `,
                },
            },
        },
    }),
    productImageBadges: productCardProps.imageBadges,
    priceAndAvailabilityGridItem: productLineProps.pricingGridItem,
    priceAndAvailabilityInnerContainer: productLineProps.pricingContainer,
    priceGridItem: productLineProps.priceGridItem,
    productPriceStyles: productCardProps.price,
    quantityBreakPricing: productCardProps.quantityBreakPricing,
    uomAndQuantityGridItem: productLineProps.unitOfMeasureGridItem,
    addToCartOptionsAndButton: mergeProps<ProductListProductCardStyles["addToCartOptionsAndButton"]>(
        productCardProps.addToCartOptionsAndButton,
        {
            flexWrapper: {
                extendedStyles: {
                    wrapper: {
                        css: css`
                            width: 100%;
                        `,
                    },
                },
            },
            quantityOrdered: {
                extendedStyles: productLineProps.textField,
            },
            unitOfMeasure: {
                extendedStyles: productLineProps.textField,
            },
        },
    ),
};

const styles = productCardStyles;

const ProductListProductCard: FC<Props> = props => {
    /* Starter Custom Code - Start */
    const {
        product,
        productInfo,
        showBrand,
        showTitle,
        showImage,
        showCompare,
        showPrice,
        showAvailability: baseShowAvailability, // Starter Custom Code
        showPartNumbers,
        showTextBadges,
        showAttributes,
        showImageBadges,
        showAddToList,
        maximumNumberOfTextBadges,
        maximumNumberOfImageBadges,
    } = props;
    const productContext: ProductContextModel = {
        product,
        productInfo,
    };

    const { productSettings } = useSettingsCollection();
    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });
    const imageBadgesNumberOfColumns = useCurrentBreakpointValue(imageBadgesNumberOfColumnsPerBreakpoint);
    const textBadgesPadding = useCurrentBreakpointValue(textBadgesPaddingPerBreakpoint);
    const showAvailability = useShowProductAvailability() && baseShowAvailability && !product.isVariantParent; // Starter Custom Code

    let variantDisplayTrait = null;
    if (product.variantTraits && product.variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = product.variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }

    const rightGridItemCss = useMemo(() => {
        if (showImage || showCompare || showAddToList) {
            return styles.rightColumnGridItem;
        }

        return mergeProps<ProductListProductCardStyles["rightColumnGridItem"]>(styles.rightColumnGridItem, {
            width: 12,
        });
    }, [showImage, showCompare, showAddToList, styles.rightColumnGridItem]);

    return (
        <GridContainer
            {...styles.gridContainer}
            data-test-selector={`productListProductCard${props.product.id}`}
            /* Store Custom Code */
            className="gridContainer"
        >
            {(showImage || showCompare || showAddToList) && (
                <GridItem {...styles.leftColumnGridItem}>
                    {(showImage || showCompare) && (
                        <StyledWrapper {...styles.imageWrapper}>
                            {product.isSponsored && (
                                <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                            )}
                            <ProductListProductImage
                                showImage={showImage}
                                showCompare={showCompare}
                                showImageBadge={showImageBadges}
                                showTextBadge={showTextBadges}
                                extendedStyles={{
                                    ...styles.productListProductImage,
                                    badgeProps: {
                                        type: BadgeTypeValues.Text,
                                        badgeTextPadding: textBadgesPadding,
                                    },
                                }}
                            />
                        </StyledWrapper>
                    )}
                    {showAddToList && <ProductAddToListLink />}
                </GridItem>
            )}
            <GridItem {...rightGridItemCss}>
                <GridContainer
                    {...styles.rightColumnGridContainer}
                    /* Store Custom Code */ className="rightColumnGridContainer"
                >
                    <GridItem {...styles.infoGridItem} className="infoGridItem">
                        <GridContainer {...styles.productInfoContainer}>
                            {((showBrand && product.brand) || showTitle) && (
                                <GridItem {...styles.descriptionGridItem}>
                                    {showBrand && product.brand && (
                                        <ProductBrand
                                            brand={product.brand}
                                            extendedStyles={styles.productBrandStyles}
                                        />
                                    )}
                                    {showTitle && (
                                        <ProductDescription
                                            product={productContext}
                                            extendedStyles={styles.productDescriptionStyles}
                                        />
                                    )}
                                </GridItem>
                            )}
                            {(showPartNumbers || showAttributes) && (
                                <GridItem {...styles.partNumbersGridItem}>
                                    {showPartNumbers && (
                                        <ProductPartNumbers
                                            productNumber={product.productNumber}
                                            customerProductNumber={product.customerProductNumber}
                                            manufacturerItem={product.manufacturerItem}
                                            extendedStyles={styles.productPartNumbersStyles}
                                        />
                                    )}
                                    {showAttributes && (
                                        <ProductAttributes
                                            maximumNumberAttributeTypes={3}
                                            extendedStyles={styles.attributes}
                                        />
                                    )}
                                </GridItem>
                            )}
                            {showAvailability && (
                                <GridItem {...styles.availabilityGridItem}>
                                    <ProductContextAvailability extendedStyles={styles.productAvailabilityStyles} />
                                </GridItem>
                            )}
                            {variantDisplayTrait ? (
                                <GridItem {...styles.swatchGridItem}>
                                    <ProductListVariantSwatch
                                        product={productContext}
                                        variantTrait={variantDisplayTrait}
                                    />
                                </GridItem>
                            ) : null}
                            {(showTextBadges && textBadges?.length) || (showImageBadges && imageBadges?.length) ? (
                                <GridItem {...styles.badgesGridItem}>
                                    {showTextBadges && textBadges && (
                                        <ProductTextBadges
                                            badgeList={textBadges}
                                            maxBadges={maximumNumberOfTextBadges ?? 4}
                                            extendedStyles={styles.productTextBadges}
                                        />
                                    )}
                                    {showImageBadges && imageBadges && (
                                        <ProductImageBadges
                                            badgeList={imageBadges}
                                            maxBadges={maximumNumberOfImageBadges ?? 4}
                                            extendedStyles={styles.productImageBadges}
                                            numberOfColumns={imageBadgesNumberOfColumns}
                                        />
                                    )}
                                </GridItem>
                            ) : null}
                        </GridContainer>
                    </GridItem>
                    <GridItem
                        {...styles.priceAndAvailabilityGridItem}
                        /* Store Custom Code */ className="priceAndAvailabilityGridItem"
                    >
                        <GridContainer
                            {...styles.priceAndAvailabilityInnerContainer}
                            /* Store Custom Code */
                            className="priceAndAvailabilityInnerContainer"
                        >
                            {showPrice && (
                                <GridItem {...styles.priceGridItem} /* Store Custom Code */ className="priceGridItem">
                                    <ProductPrice
                                        product={productContext}
                                        showSavings={true}
                                        showLabel={false}
                                        showSavingsAmount={productSettings.showSavingsAmount}
                                        showSavingsPercent={productSettings.showSavingsPercent}
                                        extendedStyles={styles.productPriceStyles}
                                    />
                                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                                </GridItem>
                            )}
                            <GridItem {...styles.uomAndQuantityGridItem}>
                                <AddToCartOptionsAndButton
                                    extendedStyles={{
                                        ...styles.addToCartOptionsAndButton,
                                        unitOfMeasure: {
                                            ...styles.addToCartOptionsAndButton?.unitOfMeasure,
                                            uid: `uom-${productContext.product.id}`,
                                        },
                                        quantityOrdered: {
                                            ...styles.addToCartOptionsAndButton?.quantityOrdered,
                                            id: `qty-ordered-${productContext.product.id}`,
                                        },
                                        addToCartButton: {
                                            ...styles.addToCartOptionsAndButton?.addToCartButton,
                                            "data-test-selector": `actionsAddToCart${productContext.product.id}`,
                                        },
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
                <ProductSearchScoreData />
            </GridItem>
        </GridContainer>
    );
    /* Starter Custom Code - End */
};

export default withProduct(ProductListProductCard);
